import React from "react";
import { NavLink } from "react-router-dom";
import { Nav } from "react-bootstrap";
import { isAdmin, isSupervisor } from "utils/utils";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const TimesNavigationTabs = ({ selectedEmployee, children }) => {
	const { t } = useTranslation();
	const user = useSelector((state) => state.authReducer.user);
	const location = useLocation();
	const groups_supervised = user.groups_supervised || [];
	const isSupervisorWithViewTimeRegistrations =
		isSupervisor() &&
		groups_supervised.length > 0 &&
		groups_supervised.some((gs) => gs.view_time_registrations ?? true);
	const canSupervise = isAdmin() || isSupervisorWithViewTimeRegistrations;

	if (!canSupervise) return null;

	const isViewingOther =
		selectedEmployee &&
		selectedEmployee.id !== user.id &&
		location.pathname !== "/my-times";
	const isMyTimesActive =
		location.pathname === "/my-times" ||
		(location.pathname.includes("/times/") &&
			location.pathname.includes("/employee"));

	const myTimesLabel =
		isViewingOther && selectedEmployee
			? t("times.tabs.employeeTimes", {
					name: `${selectedEmployee.name} ${selectedEmployee.surname || ""}`.trim(),
			  })
			: t("times.tabs.myTimes");

	const handleActiveClick = (e, isActive) => {
		if (isActive) {
			e.preventDefault();
		}
	};

	return (
		<div className="navigation-tabs-container times-navigation-tabs-container">
			<Nav variant="tabs" className="navigation-tabs">
				<Nav.Item>
					<NavLink
						to="/attendance-supervisor"
						className="nav-link"
						activeClassName="active disabled-link"
						onClick={(e) =>
							handleActiveClick(
								e,
								location.pathname === "/attendance-supervisor"
							)
						}
					>
						{t("times.tabs.supervise")}
					</NavLink>
				</Nav.Item>
				<Nav.Item>
					<NavLink
						to="/my-times"
						className={`nav-link ${isMyTimesActive ? "active disabled-link" : ""}`}
						onClick={(e) => handleActiveClick(e, isMyTimesActive)}
					>
						{myTimesLabel}
					</NavLink>
				</Nav.Item>
				<Nav.Item>
					<NavLink
						to="/time-balance"
						className="nav-link hidden-xs hidden-sm"
						activeClassName="active disabled-link"
						onClick={(e) =>
							handleActiveClick(e, location.pathname === "/time-balance")
						}
					>
						{t("times.balance.tabLabel")}
				</NavLink>
				</Nav.Item>
				<Nav.Item>
					<NavLink
						to="/without-time"
						className="nav-link"
						activeClassName="active disabled-link"
						onClick={(e) =>
							handleActiveClick(e, location.pathname === "/without-time")
						}
					>
						{t("times.tabs.without")}
					</NavLink>
				</Nav.Item>
				<Nav.Item>
					<NavLink
						to="/attendance-by-employee"
						className="nav-link"
						activeClassName="active disabled-link"
						onClick={(e) =>
							handleActiveClick(
								e,
								location.pathname === "/attendance-by-employee"
							)
						}
					>
						{t("times.tabs.byEmployee")}
						<span className="badge-new">{t("common.new")}</span>
					</NavLink>
				</Nav.Item>
			</Nav>
			{children && <div className="tabs-actions">{children}</div>}
		</div>
	);
};

export default TimesNavigationTabs;
